<template>
    <div class="order-detail-section mg20">
        <h3>退款信息</h3>
        <el-table :data="list" border :header-cell-style="{background: '#f3faff'}" :show-summary="!order.order_sensitive_masked" v-loading="loading" style="margin:20px; width:97%">
            <el-table-column prop="product_name" label="产品名称">
                <template slot-scope="scope">
                    {{scope.row.product_name}}
                </template>
            </el-table-column>
            <el-table-column prop="refund_amount" label="退款金额"></el-table-column>
            <el-table-column label="退款原因">
                <template slot-scope="scope">
                    {{scope.row.memo}}
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="退款时间"></el-table-column>
        </el-table>
    </div>
</template>
<script>
    import OrderService from "~/services/order";

    export default {
        props: {
            order: {
                required: true
            },
        },

        data() {
            return {
                list: [],
                loading: false,
            }
        },

        computed: {
            all_refund_amount() {
                if (this.order.order_sensitive_masked) {
                    return '******';
                }
                return this.list.reduce(function (sum, item) {
                    return sum + parseFloat(item.refund_amount);
                }, 0);
            }
        },

        created() {
           this.getList({order_id: this.order.id});
        },

        methods: {
            //获取列表
            getList(params) {
                // loading 动画
                this.loading = true;
                OrderService.refundLog(params).then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    this.loading = false;
                }).catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_refund.vue